export default __webpack_public_path__ + "static/media/sidebar_black.c7fc5b9f.svg";